const container = document.querySelector('.test__container');
let currentAudio = null;

container?.addEventListener('click', e => {
  const playBtn = e.target.closest('.play-btn');
  if (!playBtn) return; // клік не по кнопці

  // щоразу шукаємо актуальний audio у контейнері
  const audio = container.querySelector('audio');
  if (!audio) return;

  // якщо змінився аудіо — зупиняємо попередній
  if (currentAudio && currentAudio !== audio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    const oldBtn = container.querySelector('.is-playing');
    if (oldBtn) oldBtn.classList.remove('is-playing');
  }

  currentAudio = audio;

  if (audio.paused) {
    audio.play();
    playBtn.classList.add('is-playing');
  } else {
    audio.pause();
    playBtn.classList.remove('is-playing');
  }

  // після завершення — повертаємо у початковий стан
  audio.onended = () => {
    playBtn.classList.remove('is-playing');
  };
});
